/**
 * Feuille de style des composants WhatsApp — injectée UNE fois dans <head>.
 *
 * Les consoles ont chacune leur charte (soft UI clair, ink/or…) : les composants n'imposent rien, ils héritent
 * (`color: inherit`, `font: inherit`) et se laissent teinter par des variables CSS facultatives posées par la console :
 *   --cw-accent   couleur d'action (bouton, focus)        défaut : var(--accent, #0f8a6a)
 *   --cw-fond     fond des champs et du panneau          défaut : canvas
 *   --cw-bord     bordure                                 défaut : gris translucide
 *   --cw-rayon    arrondi                                 défaut : 10px
 */
const CSS = `
.cw-champ{display:flex;flex-direction:column;gap:6px;text-align:left}
.cw-etiquette{font-size:12.5px;font-weight:600;opacity:.85}
.cw-ligne{display:flex;gap:8px;align-items:stretch;position:relative}
.cw-pays-bouton,.cw-entree{font:inherit;color:inherit;background:var(--cw-fond,canvas);border:1px solid var(--cw-bord,rgba(128,128,128,.4));border-radius:var(--cw-rayon,10px);padding:10px 12px;min-height:42px;box-sizing:border-box}
.cw-pays-bouton{display:inline-flex;align-items:center;gap:6px;cursor:pointer;white-space:nowrap}
.cw-pays-bouton:focus-visible,.cw-entree:focus-visible,.cw-bouton:focus-visible{outline:2px solid var(--cw-accent,var(--accent,#0f8a6a));outline-offset:2px}
.cw-entree{flex:1;min-width:0;width:100%}
.cw-entree[aria-invalid="true"]{border-color:#c0392b}
.cw-code{letter-spacing:.5em;text-align:center;font-size:22px;font-variant-numeric:tabular-nums;padding-left:.5em}
.cw-liste{position:absolute;top:calc(100% + 4px);left:0;z-index:30;width:min(320px,92vw);max-height:300px;overflow:auto;background:var(--cw-fond,canvas);border:1px solid var(--cw-bord,rgba(128,128,128,.4));border-radius:var(--cw-rayon,10px);box-shadow:0 12px 32px rgba(0,0,0,.18);padding:6px}
.cw-recherche{margin:2px 2px 6px;width:calc(100% - 4px)}
.cw-option{display:flex;justify-content:space-between;gap:12px;width:100%;text-align:left;font:inherit;color:inherit;background:none;border:0;border-radius:8px;padding:8px 10px;cursor:pointer}
.cw-option:hover,.cw-option[aria-selected="true"]{background:rgba(128,128,128,.14)}
.cw-indicatif{opacity:.7;font-variant-numeric:tabular-nums}
.cw-aide{font-size:12.5px;opacity:.75;margin:0}
.cw-erreur{font-size:13px;color:#c0392b;margin:0}
.cw-bouton{font:inherit;font-weight:700;cursor:pointer;border:0;border-radius:var(--cw-rayon,10px);padding:11px 14px;min-height:44px;background:var(--cw-accent,var(--accent,#0f8a6a));color:var(--cw-sur-accent,#fff)}
.cw-bouton[disabled]{opacity:.55;cursor:not-allowed}
.cw-lien{font:inherit;background:none;border:0;padding:0;color:var(--cw-accent,var(--accent,#0f8a6a));font-weight:600;text-decoration:underline;cursor:pointer}
.cw-lien[disabled]{opacity:.55;cursor:not-allowed;text-decoration:none}
.cw-bloc{display:flex;flex-direction:column;gap:12px}
.cw-rangee{display:flex;justify-content:space-between;align-items:center;gap:12px;flex-wrap:wrap}
.cw-bascule{display:grid;grid-template-columns:1fr 1fr;gap:4px;padding:4px;border:1px solid var(--cw-bord,rgba(128,128,128,.4));border-radius:calc(var(--cw-rayon,10px) + 4px);background:rgba(128,128,128,.08)}
.cw-bascule button{font:inherit;color:inherit;font-weight:600;background:none;border:0;border-radius:var(--cw-rayon,10px);padding:8px 6px;cursor:pointer}
.cw-bascule button[aria-selected="true"]{background:var(--cw-fond,canvas);box-shadow:0 1px 4px rgba(0,0,0,.15)}
.cw-sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}
`

let injecte = false

export function injecterStyles(): void {
  if (injecte || typeof document === 'undefined') return
  injecte = true
  const style = document.createElement('style')
  style.id = 'cw-styles'
  style.textContent = CSS
  document.head.appendChild(style)
}
